angular.module('unica_feedback_category.feedback_category_services')

.factory('FeedbackCategoryEditService', function ($http, getBaseApiURL) {

	var feedbackCategoryEditService = {};

	feedbackCategoryEditService.update = function (feedbackCategoryData) {

		return $http({
			method: 'POST',
			url: getBaseApiURL + '/feedback-category/update/' + feedbackCategoryData.id,
			data: feedbackCategoryData
		}).then(function(result) {

			if ( result ) {
				return result.data.category;
			}

		});

	};

	return feedbackCategoryEditService;
});